import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useMeterReadings} from '../hooks/useMeterReadings.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useMeterReadings();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};